export default __webpack_public_path__ + "static/media/ayla.e821a152.jpeg";